export default __webpack_public_path__ + "static/media/gs8-waitlist-user-flow.0e3824b1.jpg";